import {DateTimeOffSetPipe} from './DateTimeOffsetPipe/DateTimeOffsetPipe';
import {NgModule} from '@angular/core';

@NgModule({
  declarations: [DateTimeOffSetPipe],
  exports: [DateTimeOffSetPipe],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts